import React from 'react';
import FeatureCard from './FeatureCard';

const FeaturesLayout = () => {
  return (
    <div className="new_fonctionalites_2025 featureslayout_block1">

      <div className='featureslayout_block2' >

        <h1 className='featureslayout_block_h1'>Simplifiez, optimisez et enrichissez :</h1>
      </div>
      <div className='featureslayout_block_cards' >
        <FeatureCard
          iconUrl="/img/fonctionnalite_img/img_top_mini_gestion_admin.png"
          title="Gestion administrative"
          description="Simplifiez la gestion de vos processus grâce à des outils performants : planification, automatisation et rapports."
          buttonText="Découvrir"
          module="gestion_admin"
        />
        <FeatureCard
          iconUrl="/img/fonctionnalite_img/img_top_mini_crm.png"
          title="Relation Client (CRM)"
          description="Optimisez le suivi de vos apprenants avec des tableaux de bord personnalisés."
          buttonText="Découvrir"
          module="crm"
        />
        <FeatureCard
          iconUrl="/img/fonctionnalite_img/img_top_mini_lms.png"
          title="E-learning (LMS)"
          description="Créez des parcours engageants et modulables, avec des micro-certifications et des contenus interactifs."
          buttonText="Découvrir"
          module="lms"
        />

        <FeatureCard
          iconUrl="/img/fonctionnalite_img/img_top_mini_market_place.png"
          title="Marketplace"
          description="Créez des parcours engageants et modulables, avec des micro-certifications et des contenus interactifs."
          buttonText="Découvrir"
          module="marketplace"
        />
      </div>
    </div>
  );
};

export default FeaturesLayout;

